import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Dropdown, MenuItem } from 'react-bootstrap';
import styled from 'styled-components';
import { globalStateSelector } from 'store/selector';
import { connect } from 'react-redux';
import {
  NameCard,
  DropdownToggle,
  Icon,
  ModalTrigger
} from 'modules/common/components';
import { UserHelper } from '../styles';
// import {
//   ChangePassword,
//   NotificationSettings
// } from 'modules/settings/profile/containers';

const UserInfo = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  span {
    float: none;
    margin: 0 10px;
  }
`;

const NameCardWrapper = styled.div`
  padding: 10px 20px;
`;

const NavItem = styled.div`
  padding-left: 20px;
  display: table-cell;
  vertical-align: middle;
`;

export class QuickNavigation extends Component {
  render() {
    let { logout, currentUser } = this.props;
    const { __ } = this.context;
    currentUser = currentUser || {};
    return (
      <nav>
        <NavItem>
          <Dropdown id="dropdown-user" pullRight>
            <DropdownToggle bsRole="toggle">
              <UserHelper>
                <UserInfo>
                  {currentUser.name}
                  <NameCard.Avatar user={currentUser} size={30} />
                  <Icon icon="downarrow" size={10} />
                </UserInfo>
              </UserHelper>
            </DropdownToggle>
            <Dropdown.Menu>
              <NameCardWrapper>
                <NameCard user={currentUser} />
              </NameCardWrapper>
              {/* <MenuItem divider /> */}

              {/* <li>
                <Link to={`/settings/team/details/${currentUser._id}`}>
                  {__('View Profile')}
                </Link>
              </li> */}

              <li>
                <Link to={`/justTrying`}>{__('Add Customers')}</Link>
              </li>

              {/* <ModalTrigger
                title="Change Password"
                trigger={
                  <li>
                    <a>{__('Change Password')}</a>
                  </li>
                }
              >
                <ChangePassword />
              </ModalTrigger> */}
              <MenuItem divider />
              <MenuItem onClick={logout}>{__('Sign out')}</MenuItem>
            </Dropdown.Menu>
          </Dropdown>
        </NavItem>
      </nav>
    );
  }
}
QuickNavigation.propTypes = {
  logout: PropTypes.func
};

QuickNavigation.contextTypes = {
  currentUser: PropTypes.object,
  __: PropTypes.func
};

const stateToProps = state => ({
  currentUser: globalStateSelector.getDynamic(state, { key: 'currentUser' })
});

const dispatchToProps = dispatch => ({
  dynamicUpdate: data => {
    // dispatch(globalAction.dynamicUpdate({ data }));
  }
});
export default connect(stateToProps, dispatchToProps)(QuickNavigation);



// WEBPACK FOOTER //
// src/modules/layout/components/QuickNavigation.js